import { render, staticRenderFns } from "./pageFour.vue?vue&type=template&id=9780c1e2&scoped=true&"
import script from "./pageFour.vue?vue&type=script&lang=js&"
export * from "./pageFour.vue?vue&type=script&lang=js&"
import style0 from "./pageFour.vue?vue&type=style&index=0&id=9780c1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9780c1e2",
  null
  
)

export default component.exports